/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MedicalHistoryField {
    MEDICAL_HISTORY = 'MedicalHistory',
    CURRENT_MEDICATIONS = 'CurrentMedications',
    ALLERGIES = 'Allergies',
    ANAESTHETIC_AND_SURGICAL_HISTORY = 'AnaestheticAndSurgicalHistory',
    ADDITIONAL_NOTES = 'AdditionalNotes',
}
